import React from 'react'
import {renderFragment} from "../helpers/react-helpers"
import Icon from '../components/Icon'
import icons from '../../markons/markons'
import type { DataTableDefaultRenderer, DataTableProps} from '../components/datatable';
import {DataTable} from '../components/datatable'
import {resolveRoute} from '../helpers/ajax'
import {InternalLink} from '../components/external-links'
import {NotSet} from '../components/table-links'

type UsersDtOptions = DataTableProps

const UserLink: DataTableDefaultRenderer<any> = ({data, row, meta, children}) => {
    const style = {
        maxWidth: meta.columnSettings.maxWidth,
        minWidth: meta.columnSettings.minWidth,
        width: meta.columnSettings.width,
    }
    return <InternalLink route="users.show"
        params={{id: row.id}}
        className="ellipsis"
        style={{...style, maxWidth: meta.columnSettings.maxWidth ?? meta.columnSettings.width}}>{children ||
        <NotSet />}</InternalLink>
}


export default function({
    superUser
}: any) {


    const columns: UsersDtOptions['columns'] = [
        {
            'title': 'Username',
            'data': 'username',
            // render: userLink({maxWidth: '120px'}),
            minWidth: '120px',
            // responsivePriority: 2,
        },
        {
            'title': 'Name',
            'data': 'name',
            // render: userLink({maxWidth: '120px'}),
            minWidth: '120px',
            // responsivePriority: 1
        },
        {
            'title': 'Email',
            'data': 'email',
            // render: userLink({maxWidth: '200px'}),
            width: '200px',
            // responsivePriority: 5
        },
        {
            'title': 'Role(s)',
            'data': 'roles',
            width: '250px',
            // 'sortable': true,
            // render: userLink({minWidth: '200px'}),
            // width: '220px',
            // responsivePriority: 3
        },
        {
            'title': 'Active',
            'data': 'active',
            className: 'tcenter',
            render: ({data,row}) => {
                return data ?
                    <Icon name={icons.faCheckCircle} className="payment--paid" /> :
                    <Icon name={icons.faTimesCircle} className="payment--unpaid" />
            },
            // render: displayReact2(({
            //     data,
            //     row
            // }: any) => (
            //     <a href={Router.route('users.show', {id: row.id})} style={{minWidth: '75px'}}>{data ?
            //         <Icon name={icons.faCheckCircle} className="payment--paid" /> :
            //         <Icon name={icons.faTimesCircle} className="payment--unpaid" />}</a>
            // )),
            width: '75px'
        },
    ]

    if(superUser) {
        columns.push({
            'title': 'Company',
            'data': 'company',
            'className': 'super-user-only',
            // render: userLink({maxWidth: '150px'}),
            // responsivePriority: 4
        })
    }

    const config: UsersDtOptions = {
        defaultRender: UserLink,
        rowLink: data => resolveRoute('users.show',{id: data.id}),
        ajax: {
            url: resolveRoute('api.users'),
        },
        columns,
        order: [
            ['username','asc'],
        ],
        storageKey: 'user_index',
    }

    renderFragment(<DataTable {...config} />, '#users-table')

    // $('#users-table').dataTable({
    //     ajax: {
    //         url: Router.route('api.users')
    //     },
    //     columns
    // })
}
